import { render, staticRenderFns } from "./UcDueDateRuleDisplay.yaml?vue&type=template&id=557e4424&component"
import script from "./UcDueDateRuleDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./UcDueDateRuleDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports